import { useEffect } from 'react';

import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

export const useSurvicate = () => {
	const company = useCurrentCompany();
	const user = useCurrentUser();

	useEffect(() => {
		if (company && user) {
			window._sva?.setVisitorTraits({
				company_id: company.id,
				user_id: user.id,
				email: user.email,
				is_admin: user.admin,
				is_manager: user.is_manager,
				role: user.custom_properties?.role,
				translation_setting: user.locale,
				user_mode: user.user_mode,
				department: user.custom_properties?.department,
				company: company.name,
				// user_count: Not yet available. I think company.active_human_users.count
			});
		}
	}, [company, user]);
};
